<template>
  <b-row>
    <b-col md="12" class="mb-4">
      <div style="float:right">
        <b-button variant="info" style="color:#ffffff;" v-bind:href="'#/order/product/form'">신규주문 등록</b-button>
      </div>
    </b-col>
    <b-col md="12">
      <!--
      <b-card>
        <b-row class="pt-sm-1">
          <b-col sm="1">
            <span class="card-title wise-card-title">주문 현황</span>
          </b-col>
          <b-col sm="1"><strong>기간검색</strong></b-col>
          <b-col sm="2">
            <date-picker v-model="fullDateTmp"
                        type="date"
                        range
                        placeholder="조회기간 선택"
                        :lang="datepickerLang"
                        @change="handleDateRangeChange"
                        style="width: 100%;"
            />
          </b-col>
          <b-col sm="5">
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('all')">전체</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('this_month')">이번달</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('prev_month')">지난달</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('this_year')">올해</button>
          </b-col>
          <b-col sm="2" style="text-align: center;">
              <b-button variant="primary" style="width: 100%;" v-on:click="findDrOrderTotalList()">분석</b-button>
          </b-col>
        </b-row>
      </b-card>
      -->

      <b-card>
        <b-row class="pt-sm-1">
          <b-col sm="1">
              <span class="card-title wise-card-title">검색 조건</span>
          </b-col>
          <b-col sm="1"><strong>주문검색</strong></b-col>
          <b-col sm="2">
            <b-form-select id="basicSelect" v-model="queryParams.searchType" :plain="true" :options="orderSearchTypeOption" :value="'all'"></b-form-select>
          </b-col>
          <b-col sm="6">
              <b-form-input v-model="queryParams.keyword" placeholder="" v-on:keyup="$event.keyCode === 13 ? findDrOrderList() : ''"></b-form-input>
          </b-col>
          <b-col sm="2" style="text-align: center;">
              <b-button variant="primary" style="width: 100%;" v-on:click="findDrOrderList()">검색</b-button>
          </b-col>
        </b-row>

        <b-row class="pt-sm-1">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>기간검색</strong></b-col>
          <b-col sm="2">
            <date-picker v-model="fullDateTmp"
                        type="date"
                        range
                        placeholder="조회기간 선택"
                        :lang="datepickerLang"
                        @change="handleDateRangeChange"
                        style="width: 100%;"
            />
          </b-col>
          <b-col sm="7">
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('all')">전체</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('this_month')">이번달</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('prev_month')">지난달</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('this_year')">올해</button>
          </b-col>
        </b-row>

        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>주문상태</strong></b-col>
          <b-col sm="10" style="display: inline-flex;">
            <b-form-checkbox v-model="isCheckOrderStatus" style="padding-right: 15px;" @change="allCheckOrderStatus">전체</b-form-checkbox>
            <b-form-checkbox-group v-model="queryParams.orderStatusSearchArr" @click.native="isCheckOrderStatus = false">
              <template v-for="(item, index) in orderStatusOptions">
                <b-form-checkbox :value="item.item_code">{{item.item_name}}</b-form-checkbox>
              </template>
            </b-form-checkbox-group>
          </b-col>
        </b-row>

        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>결제방식</strong></b-col>
          <b-col sm="10" style="display: inline-flex;">
            <b-form-checkbox v-model="isCheckPayType" style="padding-right: 15px;" @change="allCheckPayType">전체</b-form-checkbox>
            <b-form-checkbox-group v-model="queryParams.payTypeSearchArr" @click.native="isCheckPayType = false">
              <template v-for="(item, index) in payTypeOptions">
                <b-form-checkbox :value="item.item_code">{{item.item_name}}</b-form-checkbox>
              </template>
              <template>
                <b-form-checkbox value="eventtype">이벤트 지급</b-form-checkbox>
                <b-form-checkbox value="admintype">관리자 임의 지정</b-form-checkbox>
              </template>
            </b-form-checkbox-group>
          </b-col>
        </b-row>
      </b-card>

      <b-card>
        <div class="table-responsive-sm">
          <b-row>
            <b-col sm="12">
              <b-row>
                <b-col sm="1">
                  <span class="card-title wise-card-title">검색 기준 </span>
                </b-col>
                <b-col sm="2">
                  <div class="callout callout-info"><span class="text-muted" style="font-size:15px">총 주문내역 (건수)</span>
                    <br>
                    <button type="button" class="btn btn-link" style="font-size:15px; color:black; padding:0;" v-on:click="orderTypeSelect('')">
                      <strong class="h5"><u>￦ {{Number(orderStatus.totalOrderPrice).toLocaleString()}} ({{orderStatus.totalOrderCnt}} 건)</u></strong>
                    </button>
                  </div>
                </b-col>
                <b-col sm="2">
                  <div class="callout callout-warning"><span class="text-muted"  style="font-size:15px">입금대기</span>
                    <br>
                    <button type="button" class="btn btn-link" style="font-size:15px; color:black; padding:0;" v-on:click="orderTypeSelect('ORDER_STATUS_TYPE_1')">
                      <strong class="h5"><u>￦ {{Number(orderStatus.depositPrice).toLocaleString()}} ({{orderStatus.depositCnt}} 건)</u></strong>
                    </button>
                  </div>
                </b-col>
                <b-col sm="2">
                  <div class="callout callout-success"><span class="text-muted"  style="font-size:15px">결제완료</span>
                    <br>
                    <button type="button" class="btn btn-link" style="font-size:15px; color:black; padding:0;" v-on:click="orderTypeSelect('ORDER_STATUS_TYPE_3')">
                      <strong class="h5"><u>￦ {{Number(orderStatus.paymentPrice).toLocaleString()}} ({{orderStatus.paymentCnt}} 건)</u></strong>
                    </button>
                  </div>
                </b-col>
                <b-col sm="2">
                  <div class="callout callout-default"><span class="text-muted"  style="font-size:15px">주문취소</span>
                    <br>
                    <button type="button" class="btn btn-link" style="font-size:15px; color:black; padding:0;" v-on:click="orderTypeSelect('ORDER_STATUS_TYPE_4')">
                      <strong class="h5"><u>￦ {{Number(orderStatus.orderCancelPrice).toLocaleString()}} ({{orderStatus.orderCancelCnt}} 건)</u></strong>
                    </button>
                  </div>
                </b-col>
                <b-col sm="2">
                  <div class="callout callout-danger"><span class="text-muted"  style="font-size:15px">결제실패</span>
                    <br>
                    <button type="button" class="btn btn-link" style="font-size:15px; color:black; padding:0;" v-on:click="orderTypeSelect('ORDER_STATUS_TYPE_5')">
                      <strong class="h5"><u>￦ {{Number(orderStatus.orderPayFailPrice).toLocaleString()}} ({{orderStatus.orderPayFailCnt}} 건)</u></strong>
                    </button>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <!--
          <table id="__BVID__2714" aria-busy="false" aria-colcount="4" aria-rowcount="-1" class="table b-table table-striped">
              <thead class="" style="background-color:#f1f1f1">
                  <tr>
                      <th class="text-center" style="border-right:2px solid #a3b6c0">총 주문내역 (건수)</th>
                      <th class="text-center" style="border-right:2px solid #a3b6c0">입금대기</th>
                      <th class="text-center" style="border-right:2px solid #a3b6c0">결제완료</th>
                      <th class="text-center" style="border-right:2px solid #a3b6c0">주문취소</th>
                      <th class="text-center" >결제실패</th>
                  </tr>
              </thead>
              <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <td class="text-center" style="border-right:2px solid #a3b6c0">
                        <button type="button" class="btn btn-link" style="font-size:15px; color:black;" v-on:click="orderTypeSelect('all')">
                          <strong><u>￦ {{Number(orderStatus.totalOrderPrice).toLocaleString()}} ({{orderStatus.totalOrderCnt}} 건)</u></strong>
                        </button>
                      </td>
                      <td class="text-center" style="border-right:2px solid #a3b6c0">
                        <button type="button" class="btn btn-link" style="font-size:15px; color:black;" v-on:click="orderTypeSelect('ORDER_STATUS_TYPE_1')">
                          <strong><u>￦ {{Number(orderStatus.depositPrice).toLocaleString()}} ({{orderStatus.depositCnt}} 건)</u></strong>
                        </button>
                      </td>
                      <td class="text-center" style="border-right:2px solid #a3b6c0">
                        <button type="button" class="btn btn-link" style="font-size:15px; color:black;" v-on:click="orderTypeSelect('ORDER_STATUS_TYPE_3')">
                          <strong><u>￦ {{Number(orderStatus.paymentPrice).toLocaleString()}} ({{orderStatus.paymentCnt}} 건)</u></strong>
                        </button>
                      </td>
                      <td class="text-center" style="border-right:2px solid #a3b6c0">
                        <button type="button" class="btn btn-link" style="font-size:15px; color:black;" v-on:click="orderTypeSelect('ORDER_STATUS_TYPE_4')">
                          <strong><u>￦ {{Number(orderStatus.orderCancelPrice).toLocaleString()}} ({{orderStatus.orderCancelCnt}} 건)</u></strong>
                        </button>
                      </td>
                      <td class="text-center">
                        <button type="button" class="btn btn-link" style="font-size:15px; color:black;" v-on:click="orderTypeSelect('ORDER_STATUS_TYPE_5')">
                          <strong><u>￦ {{Number(orderStatus.orderPayFailPrice).toLocaleString()}} ({{orderStatus.orderPayFailCnt}} 건)</u></strong>
                        </button>
                      </td>
                  </tr>
              </tbody>
          </table>
          -->
        </div>
      </b-card>
    </b-col>

    <b-col md="12">
      <b-card>
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="4">
                <span class="pr-"><strong>총 {{items.length}}건</strong></span>
                <span style="color:#ea0000; font-weight:bold; font-size:15px" v-if="orderDeleteRows.length == 0">* 클릭 하시면 주문상세내역 페이지로 이동합니다.</span>
                <span style="color:#222222; font-weight:bold; font-size:15px" v-if="orderDeleteRows.length > 0">선택된 데이터 : {{orderDeleteRows.length}}</span>
                <!-- <b-button size="sm" variant="info" v-on:click="drOrderDeleteClear()" :disabled="orderDeleteRows.length == 0" :class="orderDeleteRows.length != 0 ? 'mx-1 clear_button_on' : 'mx-1 clear_button_off'"><h5 style="margin-bottom:0px"><i class="fa fa-list"></i> 초기화</h5></b-button> -->
                <!-- <span style="color:#ea0000; font-weight:bold; font-size:15px" v-if="orderDeleteRows.length == 0">* 삭제할 데이터를 선택해 주세요.</span> -->
              </b-col>
              <b-col sm="3"></b-col>
              <b-col sm="4" class="my-1">
                <!-- <b-button size="sm" variant="danger" v-on:click="drOrderDelete()" :disabled="orderDeleteRows.length == 0" :class="orderDeleteRows.length != 0 ? 'mx-1 delete_button_on float-right' : 'mx-1 delete_button_off float-right'"><h5 style="margin-bottom:0px"><i class="fa fa-remove"></i> 삭제</h5></b-button>
                <b-button size="sm" variant="success" v-on:click="downloadOrderList()" class="exceldown_button float-right"><h5 style="margin-bottom:0px"><i class="fa fa-file-excel-o"></i> 엑셀다운로드</h5></b-button> -->
                <b-button variant="outline-danger" style="float:right" v-on:click="drOrderDelete()" :disabled="orderDeleteRows.length == 0" :class="orderDeleteRows.length != 0 ? 'mx-1' : 'mx-1'">삭제</b-button>
                <b-button variant="outline-primary" style="float:right" v-on:click="downloadOrderList()">엑셀 다운로드</b-button>
              </b-col>
              <b-col md="1" class="my-1">
                <b-form-group label-cols-sm="0" label="" class="mb-0">
                  <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <!-- 로딩 -->
          <b-col sm="12" class="pt-sm-1" v-show="listLoading">
            <b-row>
              <b-col sm="6"></b-col>
              <b-col sm="6" class="pt-5 pb-5">
                <PulseLoader color="#20a8d8"></PulseLoader>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" class="pt-sm-1" v-show="!listLoading">
            <b-row>
              <b-col sm="1"></b-col>
              <b-col sm="12">
                <b-table
                  striped
                  hover
                  :selectable="productListSelect"
                  :select-mode="'multi'"
                  :fields="fieldItems"
                  :items="items"
                  :busy="items == 0"
                  :current-page="currentPage"
                  :per-page="perPage">
                  <div slot="table-busy" class="text-center my-2">
                    <strong>데이터가 없습니다.</strong>
                  </div>
                  <template slot="selectcheck" slot-scope="data">
                    <div>
                      <input type="checkbox" class="datarows" :disabled="data.item.status != 'ORDER_STATUS_TYPE_1' && data.item.status != 'ORDER_STATUS_TYPE_4' && data.item.status != 'ORDER_STATUS_TYPE_5'" v-model="data.item.selectchecked" v-on:change="drListRows()" style="vertical-align:middle; width:20px; height:20px">
                    </div>
                  </template>
                  <!-- <template slot="order_code" slot-scope="data">
                    <div>
                      <a href="javascript:void(0)" v-on:click="orderInfoGo(data.item)">{{data.item.order_code}}</a>
                    </div>
                  </template> -->
                  <template slot="order_pname" slot-scope="data">
                    <div>
                      <span class="badge badge-danger" style="font-size:12px; color:#ffffff; display:inline-block; float:left" v-if="data.item.order_new_yn == 'Y' && (data.item.pay_type == 'PAY_TYPE_1' || data.item.pay_type == 'PAY_TYPE_2')"><i class="fa fa-exclamation fa-lg"></i> NEW</span>
                      <a href="javascript:void(0)" v-on:click="orderInfoGo(data.item)" :style="data.item.order_new_yn == 'Y' && (data.item.pay_type == 'PAY_TYPE_1' || data.item.pay_type == 'PAY_TYPE_2') ? 'color:#f86c6b; font-weight:bold' : ''">{{data.item.order_pname}}</a>
                    </div>
                  </template>
                  <template slot="order_names" slot-scope="data">
                    <div v-html="data.item.order_names"></div>
                  </template>
                  <template slot="price" slot-scope="data">
                    <div style="font-weight:bold">￦ {{Number(data.item.price).toLocaleString()}}</div>
                  </template>
                  <template slot="dc_price" slot-scope="data">
                    <div style="font-weight:bold">￦ {{Number(data.item.dc_price).toLocaleString()}}</div>
                  </template>
                  <template slot="amount" slot-scope="data">
                    <div style="font-weight:bold">￦ {{Number(data.item.amount).toLocaleString()}}</div>
                  </template>
                  <template slot="status_name" slot-scope="data">
                    <div>
                      <span :class="'badge badge-'+(data.item.status == 'ORDER_STATUS_TYPE_1' ? 'primary' : data.item.status == 'ORDER_STATUS_TYPE_2' ? 'success' : data.item.status == 'ORDER_STATUS_TYPE_3' ? 'danger' : data.item.status == 'ORDER_STATUS_TYPE_4' ? 'dark' : data.item.status == 'ORDER_STATUS_TYPE_5' ? 'secondary' : '')" style="font-size:15px; color:#ffffff">
                        {{data.item.status_name}}
                      </span>
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="1"></b-col>
              <b-col sm="12" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="listRows"
                  :per-page="perPage"
                  align="center"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- <div style="float:right">
          <b-button variant="info" style="color:#ffffff" v-bind:href="'#/product/annualreport/form?status=insert'"><i class="fa fa-hand-o-up"></i> 신규등록</b-button>
        </div> -->
        <div style="float:right">
          <b-button variant="info" style="color:#ffffff;" v-bind:href="'#/order/product/form'">신규주문 등록</b-button>
        </div>
      </b-card>
    </b-col>
  </b-row>



</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { codeAPI } from '../../common/code.js';
import swal from 'sweetalert2'
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

const moment = require("moment");

export default {
  components: {
    DatePicker,
    PulseLoader,
  },
  data() {
    return {
      listLoading: true,
      datepickerLang: {
                yearFormat: "YYYY년",
                monthFormat: "M월",
                days:["일","월","화","수","목","금","토"]
            },
      fullDateTmp: [],
      productListSelect: false,
      dr_topdeth_code: '',
      dr_rtype: '',
      resultCateDatas: [], // code.js 각 코드들의 결과값
      orderSearchTypeOption: [
        {text:'전체', value:'all'},
        {text:'상품명', value:'order_pname'},
        {text:'주문자 아이디', value:'user_id'},
        {text:'주문자 명', value:'user_name'},
        {text:'휴대폰번호', value:'user_mobile'},
        // {text:'주문번호', value:'order_code'},
      ], // 상단 구분 셀렉트 박스 코드값
      selectCateItems: [], // 상단 구분 셀렉트 박스 코드값
      myToggle: false,
      // totalRows: 30,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      orderDeleteRows: [],
      orderParams: {},
      queryParams: {
        dr_deth_code: '',
        searchType: 'all',
        type_code: 'all',
        day_code: '',
        categoryitems: [],
        start_date: '',
        end_date: '',
        orderStatusSearchArr: [], //주문상태 배열
        payTypeSearchArr: [],     //결제방식 배열
      },
      orderStatusCode: '',
      orderStatusArr: {all:true},
      payTypeArr: {all:true},
      isCheckOrderStatus: false,  //주문상태 전체선택
      isCheckPayType: false,      //결제방식 전체선택
      orderStatusOptions: [],     //주문상태 옵션리스트
      payTypeOptions: [],         //결제방식 옵션리스트
      fieldItems: [{
        'selectcheck': {
          'label': '선택',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      },{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'status_name': {
          'label': '주문상태',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      //   'order_code': {
      //     'label': '주문번호',
      //     'class': 'text-center',
      //     'tdClass': 'text-vmiddle',
      //     'thStyle': {
      //        'vertical-align': 'middle'
      //     }
      //   }
      }, {
        'op_type_name': {
          'label': '상품구분',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'order_pname': {
          'label': '상품명',
          // 'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }, {
        'company': {
          'label': '회사명',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'order_names': {
          'label': '주문자(아이디)',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'order_date': {
          'label': '주문일',
          'sortable': true,
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'text-align': 'center',
             'vertical-align': 'middle'
          }
        }
      }, {
        'pay_type_name': {
          'label': '결제방식',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'price': {
          'label': '주문금액',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'dc_price': {
          'label': '할인금액',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      // }, {
      //   'dc_type': {
      //     'label': '할인유형',
      //     'class': 'text-center',
      //     'tdClass': 'text-vmiddle',
      //     'thStyle': {
      //        'vertical-align': 'middle'
      //     }
      //   }
      }, {
        'amount': {
          'label': '결제금액',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {

      }],
      items: [],
      orderStatus: {
        totalOrderCnt: 0,
        totalOrderPrice: 0,
        depositCnt: 0,
        depositPrice: 0,
        paymentCnt: 0,
        paymentPrice: 0,
        orderCancelCnt: 0,
        orderCancelPrice: 0,
        orderPayFailCnt: 0,
        orderPayFailPrice: 0,
      },
      categoryButtons: [],
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  watch: {
    'productListSelect'(newId, oldId) {
      this.orderDeleteRows = [];
    }
  },
  mounted: function() {
     // /contents/trendbrief
     var self = this;
     // 상단 셀렉트 박스 코드 조회
     codeAPI.selectItemCodeList(self,"ORDER_STATUS_TYPE",2,"orderStatusOptions");
     codeAPI.selectItemCodeList(self,"PAY_TYPE",2,"payTypeOptions");
     self.productInit();
  },
  methods: {
    productInit() {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      var drCodeArr = {};

      self.dateRange('this_month');
      // self.findDrOrderTotalList();
      self.findDrOrderList();

    },
    // 메소드명 : findDrOrderList()
    // ### 주문리스트 조회 ###
    // 주문내역의 리스트를 DB테이블에서 조회한다.
    //
    // 최초작성 : 2016.08.27
    // 파라미터 :
    //  - orderStatusArr(주문상태 검색 배열)
    //  - payTypeArr(결제방식 검색 배열)
    //  - keyword(검색명)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.08.27  황경현   최초작성
    // *************************
    findDrOrderList() {
      this.listLoading = true;

      var self = this;
      var token = sessionStorage.getItem("myToken");

      self.queryParams.order_type = "RP";
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('orderObjs', param);

      self.$http.post('/api/select/drOrderList?access_token=' + token, data, null)
      .then((result) => {
        self.items = result.data;
        self.items.forEach(function (el, idx, arr){
          el.rnum = self.items.length - (idx);
          el.selectchecked = false;
        });

        // self.findDrOrderTotalList();
        self.orderStatus = {
          totalOrderCnt: 0,
          totalOrderPrice: 0,
          depositCnt: 0,
          depositPrice: 0,
          paymentCnt: 0,
          paymentPrice: 0,
          orderCancelCnt: 0,
          orderCancelPrice: 0,
          orderPayFailCnt: 0,
          orderPayFailPrice: 0,
        };

        // self.items = result.data;
        self.orderStatus.totalOrderCnt = result.data.length;
        result.data.forEach(function (el, idx, arr){
          self.orderStatus.totalOrderPrice += parseInt(el.amount);
          if(el.status == "ORDER_STATUS_TYPE_1"){
            self.orderStatus.depositCnt++;
            self.orderStatus.depositPrice += parseInt(el.amount);
          }
          if(el.status == "ORDER_STATUS_TYPE_3"){
            self.orderStatus.paymentCnt++;
            self.orderStatus.paymentPrice += parseInt(el.amount);
          }
          if(el.status == "ORDER_STATUS_TYPE_4"){
            self.orderStatus.orderCancelCnt++;
            self.orderStatus.orderCancelPrice += parseInt(el.amount);
          }
          if(el.status == "ORDER_STATUS_TYPE_5"){
            self.orderStatus.orderPayFailCnt++;
            self.orderStatus.orderPayFailPrice += parseInt(el.amount);
          }
        });

        this.listLoading = false;
      })
    },
    findDrOrderTotalList() {
      var self = this;
      var token = sessionStorage.getItem("myToken");

      self.queryParams.order_type = "RP";
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('orderObjs', param);

      self.$http.post('/api/select/drOrderTotalList?access_token=' + token, data, null)
      .then((result) => {
        self.orderStatus = {
          totalOrderCnt: 0,
          totalOrderPrice: 0,
          depositCnt: 0,
          depositPrice: 0,
          paymentCnt: 0,
          paymentPrice: 0,
          orderCancelCnt: 0,
          orderCancelPrice: 0,
          orderPayFailCnt: 0,
          orderPayFailPrice: 0,
        };

        // self.items = result.data;
        self.orderStatus.totalOrderCnt = result.data.length;
        result.data.forEach(function (el, idx, arr){
          self.orderStatus.totalOrderPrice += parseInt(el.amount);
          if(el.status == "ORDER_STATUS_TYPE_1"){
            self.orderStatus.depositCnt++;
            self.orderStatus.depositPrice += parseInt(el.amount);
          }
          if(el.status == "ORDER_STATUS_TYPE_3"){
            self.orderStatus.paymentCnt++;
            self.orderStatus.paymentPrice += parseInt(el.amount);
          }
          if(el.status == "ORDER_STATUS_TYPE_4"){
            self.orderStatus.orderCancelCnt++;
            self.orderStatus.orderCancelPrice += parseInt(el.amount);
          }
          if(el.status == "ORDER_STATUS_TYPE_5"){
            self.orderStatus.orderPayFailCnt++;
            self.orderStatus.orderPayFailPrice += parseInt(el.amount);
          }
        });

        // self.findDrOrderList();
      })
    },
    // 메소드명 : productPkgOptions(row_pcode)
    // ### 옵션 수정 ###
    // 해당 상품의 옵션 수정 화면으로 이동한다.
    //
    // 최초작성 : 2016.07.02
    // 파라미터 :
    //  - row_pcode(해당 상품 코드)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜     작성자     수정내용
    // 2019.07.02  황경현    최초작성
    // *************************
    productPkgOptions(row_pcode) {
      var self = this;
      self.$session.set('p_param_code', row_pcode);
      location.href = '#/product/annualreport/form?status=update&pkgtype=on';
    },
    drListRows() {
      var self = this;
      self.orderDeleteRows = [];
      self.items.forEach(function (el, idx, arr){
        if(el.selectchecked){
          self.orderDeleteRows.push(el.order_code);
        }
      });
    },
    drOrderDelete(){
      var self = this;
      swal.fire({
        title: '주문 삭제!',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        html: "<b>해당 주문의 모든 데이터가 영구 삭제 됩니다.</br> 삭제하시겠습니까?</br><span style='color:#ea0000'>삭제 데이터 수 : "+self.orderDeleteRows.length+"건</span></b>",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          // ok
          console.log(self.orderDeleteRows);
          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(self.orderDeleteRows));
          var data = new FormData();
          data.append('orderDelArr', param);

          self.$http.post('/api/delete/drOrderData?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '주문이 정상적으로 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.orderDeleteRows = [];
                $(".datarows").prop("checked", false);
                self.findDrOrderList();
              });
          })
        }else{
          // cansel
        }
      })
    },
    drOrderDeleteClear() {
      this.orderDeleteRows = [];
      this.items.forEach(function (el, idx, arr){
        el.selectchecked = false;
      });
    },
    orderInfoGo(row) {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      self.orderParams.order_code = row.order_code;
      var param = encodeURI(JSON.stringify(self.orderParams));
      var data = new FormData();
      data.append('orderObj', param);

      self.$http.post('/api/update/drOrderNewCheck?access_token='+token, data, null)
        .then((result) => {
          self.$session.set('param_order_code', row.order_code);
          self.$store.dispatch('ORDERTOTALCNT', self);
          location.href = '#/order/product/info';
      })
    },
    // 날짜 정의
    dateRange(flag) {
      let endDate = new Date();
      let startDate = new Date();

      if(flag == 'this_month'){
        startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
        endDate = new Date();
      }else if(flag == 'prev_month'){
        startDate = new Date(endDate.getFullYear(), endDate.getMonth() - 1, 1);
        endDate = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
      }else if(flag == 'this_year'){
        startDate = new Date(endDate.getFullYear(), 0, 1);
        endDate = new Date();
      }
      this.fullDateTmp = [startDate, endDate];
      if(flag == 'all'){
        this.fullDateTmp = [];
      }
      this.handleDateRangeChange();
    },
    handleDateRangeChange() {
      var self = this;
      if(self.fullDateTmp.length > 0){
        self.queryParams.start_date = moment(self.fullDateTmp[0]).format("YYYY-MM-DD");
        self.queryParams.end_date = moment(self.fullDateTmp[1]).format("YYYY-MM-DD");
      }else{
        self.queryParams.start_date = '';
        self.queryParams.end_date = '';
      }
    },
    orderTypeSelect (type_code) {
      var self = this;
      self.orderStatusCode = type_code;
      self.findDrOrderList();
      self.orderStatusCode = ''; //통계분석용으로 1회 쓰고 초기화
    },
    downloadOrderList(){
      var self = this;
      self.isDownload = true;
      var token = sessionStorage.getItem("myToken");

      const { manager_id } = self.$session.get('userInfo');
      self.queryParams.manageId = manager_id;

      var param = encodeURI(JSON.stringify(self.queryParams));

      var data = new FormData();
      data.append('objs', param);

      var config = {
          responseType: 'blob'
      };

      self.$http.post('/api/download/orderListExcel?access_token='+token, data, config)
          .then((result) => {
            const url = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement('a');
            link.href = url;
            var fileName = "보고서상품주문리스트_" + moment().format('YYYYMMDD');
            link.setAttribute('download', fileName + '.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.isDownload = false;
          });
    },

    //주문상태 전체선택 이벤트
    allCheckOrderStatus(){
      this.isCheckOrderStatus = !this.isCheckOrderStatus;
      if(this.isCheckOrderStatus) {
        this.queryParams.orderStatusSearchArr = [];
        this.orderStatusOptions.forEach((data) => {
          this.queryParams.orderStatusSearchArr.push(data.item_code);
        });
      }else{
        this.queryParams.orderStatusSearchArr = [];
      }
    },
    //결제방식 전체선택 이벤트
    allCheckPayType(){
      this.isCheckPayType = !this.isCheckPayType;
      if(this.isCheckPayType) {
        this.queryParams.payTypeSearchArr = [];
        this.payTypeOptions.forEach((data) => {
          this.queryParams.payTypeSearchArr.push(data.item_code);
        });
        this.queryParams.payTypeSearchArr.push('eventtype');
        this.queryParams.payTypeSearchArr.push('admintype');
      }else{
        this.queryParams.payTypeSearchArr = [];
      }
    },
  }
}

</script>
<style lang="css" scoped>
  .text-vmiddle {vertical-align: middle;}
  .delete_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #f42f2d; font-size:15px}
  .delete_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #f42f2d; font-size:15px}
  .clear_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #55a0bb; font-size:15px}
  .clear_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #55a0bb; font-size:15px}
  .exceldown_button {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #1c9847; font-size:15px}
</style>



// WEBPACK FOOTER //
// src/views/order/OrderProductList.vue